import React from "react";
import { SvgIcon } from "@material-ui/core";

const AppleIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 9.23 11.742">
      <path
        id="path4"
        d="M9.037,9.151a6.528,6.528,0,0,1-.589,1.135,5.692,5.692,0,0,1-.759.983,1.427,1.427,0,0,1-.975.46,2.31,2.31,0,0,1-.9-.23,2.44,2.44,0,0,0-.97-.23,2.521,2.521,0,0,0-1,.23,2.541,2.541,0,0,1-.862.243,1.344,1.344,0,0,1-1-.473,5.971,5.971,0,0,1-.794-1.018A7.243,7.243,0,0,1,.352,8.465,6.964,6.964,0,0,1,0,6.336,4.109,4.109,0,0,1,.477,4.3a2.907,2.907,0,0,1,1-1.082,2.552,2.552,0,0,1,1.349-.408,3,3,0,0,1,1.044.26,3.183,3.183,0,0,0,.828.261,4.709,4.709,0,0,0,.918-.307,2.853,2.853,0,0,1,1.248-.237A2.605,2.605,0,0,1,8.936,3.959,2.509,2.509,0,0,0,7.712,6.206a2.564,2.564,0,0,0,.76,1.868,2.488,2.488,0,0,0,.759.533q-.091.284-.193.544ZM6.922.235a2.609,2.609,0,0,1-.6,1.643,2,2,0,0,1-1.7.9,1.957,1.957,0,0,1-.013-.223A2.675,2.675,0,0,1,5.25.893,2.472,2.472,0,0,1,6.025.269,2.192,2.192,0,0,1,6.911,0a2.285,2.285,0,0,1,.012.235Z"
        transform="translate(0 -0.001)"
      />
    </SvgIcon>
  );
};

export default AppleIcon;
